import { createApp } from 'vue'
import ShRS from './ShRS.vue'
import BotStats from './BotStats.vue'

createApp(BotStats).mount('#app')
createApp(ShRS).mount('#app')